export default "__VITE_ASSET__q0ZV1RAy__"